import React, {Component} from 'react';
import { connect } from 'react-redux'
import Registry from "../../../registry";

import SettingsPopup from '../SettingsPopup/index';
import UserSettings from '../SettingsPopup/UserSettings';
import GearIcon from '../UIKit/Icon/Gear';
import Anchor from '../UIKit/Anchor';

import './style.scss'

class SidebarMenu extends Component {
    constructor(props) {
        super(props);
        this.onOptionsClick = this.onOptionsClick.bind(this);
    }

    onOptionsClick(event) {
        event.preventDefault();

        openOptions(this.props.currentUser, this.props.currentRoom);
    }

    render() {
        let lang = Registry.get('locale');

        return (
            <ul className="sidebar-menu">
                <li>
                    <a onClick={this.onOptionsClick} className="settings">{lang.settings}</a>
                </li>
                <li>
                    <a href={lang.url.help} className="faq" target="_blank">{lang.help}</a>
                </li>
            </ul>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        currentUser: state.currentUser,
        currentRoom: state.currentRoom
    }
}

export function openOptions(currentUser, currentRoom) {
    let lang = Registry.get('locale');
    SettingsPopup.open({
        title: lang.settings,
        content: <UserSettings currentUser={currentUser} 
                            onCancel={() => SettingsPopup.close()}
                            onSuccess={() => SettingsPopup.close()}/>,
        currentUser: currentUser,
        currentRoom: currentRoom
    });
}

export default connect(mapStateToProps)(SidebarMenu);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SidebarMenu/index.js